import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f218b36"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = {
  id: "slip-form",
  class: "m-auto"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "alert alert-warning mt-3"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "delivery-date" }, "納品日", -1))
const _hoisted_7 = ["readonly"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "slip-to" }, "宛先", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_13 = ["textContent", "value"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "slip-cc" }, "CC", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "slip-subject" }, "件名", -1))
const _hoisted_24 = ["readonly"]
const _hoisted_25 = ["textContent"]
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "slip-body" }, "本文", -1))
const _hoisted_28 = ["readonly"]
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!
  const _component_add_mail_address_dialog = _resolveComponent("add-mail-address-dialog")!
  const _component_confirm_send_slip_dialog = _resolveComponent("confirm-send-slip-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_content_layout, null, {
      header: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createTextVNode("納品書作成（"),
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.company.name)
          }, null, 8, _hoisted_1),
          _createTextVNode("）")
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary",
            to: { name: 'DeliverySlipList', params: { companyKey: _ctx.company.key } }
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" 戻る ")
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 送信済みの納品書のため、編集・送信不可 "))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: "mt-5",
            onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onModified && _ctx.onModified(...args))),
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onModified && _ctx.onModified(...args)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.deliveryDate }]),
                id: "delivery-date",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.deliveryDate) = $event)),
                readonly: _ctx.isReadOnly
              }, null, 10, _hoisted_7), [
                [_vModelText, _ctx.values.deliveryDate]
              ]),
              _createElementVNode("div", {
                class: "invalid-feedback",
                textContent: _toDisplayString(_ctx.errors.deliveryDate)
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.userKey }]),
                id: "slip-to",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.userKey) = $event)),
                disabled: _ctx.isReadOnly
              }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminUsers, (u) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: u.key,
                    textContent: _toDisplayString(u.loginId),
                    value: u.key
                  }, null, 8, _hoisted_13))
                }), 128))
              ], 10, _hoisted_11), [
                [_vModelSelect, _ctx.values.userKey]
              ]),
              _createElementVNode("div", {
                class: "invalid-feedback",
                textContent: _toDisplayString(_ctx.errors.userKey)
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-sm ml-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showingAddDialog = true))
                  }, [
                    _hoisted_17,
                    _createTextVNode(" 追加 ")
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ccList, (cc) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row mt-3",
                  key: cc
                }, [
                  (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-danger col-1",
                        onClick: ($event: any) => (_ctx.removeMailAddress(cc))
                      }, _hoisted_20, 8, _hoisted_18))
                    : _createCommentVNode("", true),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control col-11",
                    id: "slip-cc",
                    readonly: "",
                    value: cc
                  }, null, 8, _hoisted_21)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.subject }]),
                id: "slip-subject",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.subject) = $event)),
                readonly: _ctx.isReadOnly
              }, null, 10, _hoisted_24), [
                [_vModelText, _ctx.values.subject]
              ]),
              _createElementVNode("div", {
                class: "invalid-feedback",
                textContent: _toDisplayString(_ctx.errors.subject)
              }, null, 8, _hoisted_25)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _withDirectives(_createElementVNode("textarea", {
                id: "slip-body",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.body }]),
                rows: "15",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.body) = $event)),
                readonly: _ctx.isReadOnly
              }, "\r\n            ", 10, _hoisted_28), [
                [_vModelText, _ctx.values.body]
              ]),
              _createElementVNode("div", {
                class: "invalid-feedback",
                textContent: _toDisplayString(_ctx.errors.body)
              }, null, 8, _hoisted_29)
            ])
          ], 32),
          _createVNode(_component_dismissible_alert, {
            color: "danger",
            message: _ctx.requestError,
            onDismiss: _cache[7] || (_cache[7] = ($event: any) => (_ctx.requestError = null))
          }, null, 8, ["message"]),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn btn-outline-info",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args))),
                  disabled: !_ctx.meta.valid
                }, "下書き保存", 8, _hoisted_31),
                (_ctx.isSavedDraft)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger ml-2",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showingConfirmDialog = true)),
                      disabled: _ctx.isModified
                    }, " 送信 ", 8, _hoisted_32))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showingAddDialog)
          ? (_openBlock(), _createBlock(_component_add_mail_address_dialog, {
              key: 0,
              onDismiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showingAddDialog = false)),
              onAdd: _ctx.addMailAddress
            }, null, 8, ["onAdd"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showingConfirmDialog)
          ? (_openBlock(), _createBlock(_component_confirm_send_slip_dialog, {
              key: 0,
              onDismiss: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showingConfirmDialog = false)),
              onSendSlip: _ctx.sendSlip
            }, null, 8, ["onSendSlip"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}